<template>
  <div class="m-yunxiao parent time-off-details">
    <div class="main">
      <div class="top-line">
        <div class="name-column">
          <div class="photo-nav" v-if="!infos.student || !infos.student.photo">
            {{ infos.student.name && infos.student.name.substr(-2) }}
          </div>
          <img class="photo-nav" v-else :src="infos.student.photo.url" />
          <div class="name">
            <span>{{(infos.student && infos.student.name)||'-'}}</span>
            <!-- v-if="infos && infos.student && infos.student.parentPhone" -->
            <a  
              v-if="infos && infos.student && infos.student.phone"
              class="call" 
              :href="'tel:' + infos.student.phone">
            </a>
          </div>
        </div>
        <div class="status-column" :class="['status' + (infos.status-1)]">
          {{statusDesc[infos.status-1]}}
        </div>
      </div>
      <div>
        <div class="title van-hairline--bottom">
          请假课次
        </div>
        <div class="line">
          <div class="label">上课时间：</div>
          <div class="content">
            {{infos.courseArrange.startTime | formatDatetime('yyyy-MM-dd hh:mm')}}
            -
            {{infos.courseArrange.endTime | formatDatetime('hh:mm')}}
          </div>
        </div>
        <div class="line">
          <div class="label">课程名称：</div>
          <div class="content">
            <span v-if="infos.courseArrange && infos.courseArrange.curriculumName">{{infos.courseArrange.curriculumName}}</span>
            <span class="tips" v-if="infos.stat && infos.stat.priceItemLeaveCount">
              该课程已请{{infos.stat.priceItemLeaveCount}}次 
              <span style="color:var(--tlc)" @click="showLog">查看</span>
            </span>

          </div>
        </div>
        <div class="line">
          <div class="label">上课老师：</div>
          <div class="content">{{attendClassTeachersText}}</div>
        </div>
        <div class="line">
          <div class="label">上课校区：</div>
          <div class="content">{{(infos.courseArrange && infos.courseArrange.campusName )||'-'}}</div>
        </div>

      </div>
      <div>
        <div class="title van-hairline--bottom">
          申请信息
        </div>
        <div class="line">
          <div class="label">申请原因：</div>
          <div class="content">{{infos.reason||'-'}}</div>
        </div>
      </div>

      <div>
        <div class="title van-hairline--bottom">
          审批信息
        </div>
        <van-steps 
          direction="vertical" 
          class="time-off-status"
          :active="active" 
          finish-icon="checked"
          :inactive-icon="['more', 'checked','clear', 'revoke', 'revoke'][infos.status-1]"
          :class="[['waitting', 'agree','disagree', 'revoke', 'revoke'][infos.status-1]]">
          <van-step 
            v-for="(operat,idx) of infos.operateLogList" 
            :key="idx">
            <template v-slot:inactive-icon v-if="infos.status===6"><i class="vxs-icon vxs-icon-jian" ></i></template>
            <p class="title-line">{{operateTypes[operat.operateType-1]}}<span>{{operat.createTime | formatDatetime('yyyy-MM-dd hh:mm')}}</span></p>
            <p class="tips-line">{{operat.operatorName}}</p>

            <p class="ramark-line" v-if="infos.status !== 1  && operat.remark ">
              {{operat.remark}}
            </p>
          </van-step>
          <van-step v-if="infos.operateLogList.length === 1">
            <p class="title-line">待处理</p>
          </van-step>
        </van-steps>
      </div>
    </div>
    <div class="footer" v-if="infos.status === 1 && app.permission.op('handle_leave')">
      <van-button block square round @click="approver(false)">拒绝</van-button>
      <van-button block square round type="primary" @click="approver(true)">同意</van-button>
    </div>
    <div class="footer" v-if="infos.status === 2 && app.permission.op('invalid_leave')">
      <van-button block square round type="primary" @click="invalidLeave(true)">作废请假</van-button>
    </div>
    <van-popup 
      :safe-area-inset-bottom="true"
      class="show-history-popup"
      v-model="showHistoryPopup" 
      position="bottom" 
      :get-container="()=>this.$el"      
      closeable
      :style="{ height: '312px' }" >
      <div class="title">
        请假记录({{historyLog.length}}次)
      </div>
      <div class="body">
        <div class="van-hairline--bottom" v-for="item of historyLog" :key="item.id">
          <div class="line">
            <div class="label">时间：</div>
            {{item.courseArrangeStartTime | formatDatetime('yyyy-MM-dd hh:mm')}}
            -
            {{item.courseArrangeEndTime | formatDatetime('hh:mm')}}
          </div>
          <div class="line">
            <div class="label">原因：</div>{{ item.reason || '-' }}
          </div>
        </div>
      </div>
    </van-popup>
    <van-dialog 
      v-model="showInvalid" 
      title="作废请假" 
      show-cancel-button 
      confirmButtonText="作废" 
      confirmButtonColor="#EE0A24"
      @confirm="submitInvalid"
      @cancel="cancelInvalid">
        <van-field type="textarea"
        rows="3"
        v-model="leaveRemark"
        autosize
        maxlength="200"
        placeholder="请输入原因（选填）"
        show-word-limit
        ></van-field>
    </van-dialog>
  </div>
</template>

<script>
import { statusDesc, operateTypes } from '@parent/views/base/time-off/desc.js';

export default {
  name: 'timeoffDetails',
  data () {
    return {
      leaveRemark:'',
      showInvalid:false,
      pageTitle: '请假',
      id: this.$vxRoute.params.id,
      statusDesc,
      operateTypes,
      infos: {
        student: {},
        courseArrange: {},
        operateLogList: []
      },
      showHistoryPopup: false,
      historyLog: [],
      active: 0,
    }
  },
  computed: {
    attendClassTeachersText: function () {
      let attendClassTeachers = this.infos.courseArrange.courseArrangeTeacherList || [];
      let tcs = attendClassTeachers.filter(v=>v.teacherRule === 0).map(v=>v.teacherName);
      if (tcs.length) {
        return tcs.join("、");
      } else {
        return `未设置`
      }
    },
  },
  methods: {
    submitInvalid(){
      this.showLoading();
      this.$api.invalid({
        leaveId: this.id,
        remark: this.leaveRemark,
      })
        .then(res=>{
          if (res.code === 200){
            this.$toast.success('作废成功');
            this.getDatas();
            this.cancelInvalid()
           }
           if (res.code > 60000) {
             app.http.tipErr(res.msg || '网络异常，请稍后重试');
           }
        })
        .catch(err=>{
          console.log(err)
        })
    },
    cancelInvalid(){
      this.showInvalid=false;
      this.leaveRemark=''
    },
    getDatas () { 
      this.showLoading();
      this.$api.getLeaveDetails({
        leaveId: this.id,
      })
        .then(res=> {
          if (res.code === 200) {
            this.$toast.clear();
            this.infos = res.data || {};
            !this.infos.courseArrange && (this.infos.courseArrange = {});
            !this.infos.student && (this.infos.student = {});
            !this.infos.operateLogList && (this.infos.operateLogList = []);

            // 正常只会有两步，带有系统撤回(已同意的情况下删除排课)的情况下会出现三条记录
            if (this.infos.status!==1 && this.infos.operateLogList.length>2) {
              let operate = this.infos.operateLogList[1];
              // 有三条操作记录，且第二条是同意
              // 将active置为1，用于第二步也显示checked图标
              this.active = Number(operate && operate.operateType === 2);
            }

          }
          if (res.code > 60000) {
            app.http.tipErr(res.msg || '网络异常，请稍后重试');
          }
        })
        .catch(err=>{
          console.log(err)
        })
    },
    approver (accept = true) {
      let sideConfig = {
        showCancelButton: false,
      };
      if (!accept) { sideConfig.pageTitle = '拒绝请假'}
      app.x3.side.xsApprovalOpinion({config: sideConfig})
        .then(res=>{
          this.showLoading();
          this.$api.leaveReview({
            accept,
            leaveId: this.id,
            remark: res.reason,
          })
            .then(res=>{
              if (res.code === 200) {
                this.$toast.success('审批成功');
                this.getDatas();
                app.vue.$emit('refresh-timeoff-list');
              }
              if (res.code > 60000) {
                app.http.tipErr(res.msg || '网络异常，请稍后重试');
              }
            })

        })
    },
    invalidLeave(){
      this.showInvalid=true
    },
    showLog () {
      this.showLoading();
      this.$api.leavePriceItemLeaveList({
        studentId: this.infos.student.studentId,
        curriculumId: this.infos.courseArrange.curriculumId,
      })
        .then(res=>{
          if (res.code === 200){
            this.$toast.clear();
            this.showHistoryPopup = true;
            this.historyLog = res.data;
           }
           if (res.code > 60000) {
             app.http.tipErr(res.msg || '网络异常，请稍后重试');
           }
        })
        .catch(err=>{
          console.log(err)
        })
    }
  },  
  created () {
    this.getDatas();
  }
}
</script>

<style lang="scss" scoped>
.m-yunxiao.parent.time-off-details{
  display: flex;
  flex-direction: column;
  .main {
    flex: 1;
    padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
    >div{
      margin-bottom: calc(var(--gap) * 12);
      padding: calc(var(--gap) * 16);
      border-radius: var(--radius-sm);
      background-color: var(--white);
      >.title{
        margin-bottom: calc(var(--gap) * 4);
        padding-bottom: calc(var(--gap) * 12);
        font-size:var(--fs-lg);
        line-height:var(--lh-lg);
        font-weight: var(--bold);
      }
      >div.line{
        margin-top: calc(var(--gap) * 8);
        display: flex;
        .label{
          // white-space: nowrap;
          flex-shrink: 0;
          color: var(--g6);
        }
        .content{
          >span.tips{
            font-size:var(--fs-sm);
            line-height:var(--lh-sm);
            color:var(--g6);
          }
        }
      }

      >div.time-off-status{
        ::v-deep .van-step__circle-container{
          font-size:var(--fs-lg);
          top: 21px;
        }
        ::v-deep .van-step{
          top: 21px;
        }
        ::v-deep .van-hairline{
          &::after{
            display: none;
          }
        }
        ::v-deep .van-step__icon--finish,
        ::v-deep .van-step__icon--active{          
          color: var(--c2);
        }
        ::v-deep .van-step--finish>.van-step__line{
          background-color: var(--g3);
        }
        .title-line{
          display: flex;
          justify-content: space-between;
          font-size:var(--fs-md);
          line-height:var(--lh-md);
          color: var(--g8);
          margin: 0 0 calc(var(--gap) * 8);
          >span{
            font-size:var(--fs-sm);
            line-height:var(--lh-sm);
            color: var(--g5);
          }
        }
        .tips-line{      
          margin: 0 0 calc(var(--gap) * 8) 0;    
          font-size:var(--fs-sm);
          line-height:var(--lh-sm);
          color: var(--g6);
        }
        .ramark-line{
          padding: calc(var(--gap) * 4) calc(var(--gap) * 8);
          margin: calc(var(--gap) * -3) 0 calc(var(--gap) * 12) 0;
          border-radius: var(--radius-base);
          background-color: var(--g1);
          overflow: hidden;
          color: var(--g6);
        }
      }
      >div.time-off-status.waitting {
        ::v-deep .van-step__circle-container{
          color: var(--c4);
        }
      }
      >div.time-off-status.disagree {
        ::v-deep .van-step__circle-container{
          color: var(--c3);
        }
      }
      >div.time-off-status.agree {
        ::v-deep .van-step__circle-container{
          color: var(--c2);
        }
      }
      >div.time-off-status.revoke{
        ::v-deep .van-icon-revoke{
          display: flex;
          align-items: center;
          justify-content: center;
          width: calc(var(--w) * 16);
          height: calc(var(--w) * 16);
          font-size:var(--fs-sm);
          color: var(--white);
          background-color: var(--g4);
          border-radius: 50%;
        }
      }
    }
    .top-line{
      margin-bottom: calc(var(--gap) * 8);
      display: flex;
      align-items: center;
      justify-content: space-between;
      .name-column{
        max-width: calc(100% - var(--w) * 45);
        display: flex;
        align-items: center;
        .photo-nav {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          width: calc(var(--w) * 36);
          height: calc(var(--w) * 36);
          font-size: var(--fs-md);
          line-height: var(--lh-md);
          color: var(--white);
          background-color: var(--c1);
          border-radius: 50%;
          border: unset;
          outline: unset;
          margin-right: calc(var(--gap) * 8);
        }
        .name{
          line-height: var(--lh-sm);
          >span{
            padding-right: calc(var(--gap) * 8);
          }
        }      
        .name>a {
          padding: calc(var(--gap) * 4) calc(var(--gap) * 12);
          background-size: calc(var(--w) * 24);
          &.call{ 
            background-image: url('https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0009.png?t=1623047937522');
          }
        }

      }
      .status-column{
        margin-left: calc(var(--gap) * 8);
        width: calc(var(--w) * 45);
        text-align: right;
        color: var(--g6);
        white-space: nowrap;
        &.status0{
          color: var(--c4);
        }
        &.status1{
          color: var(--c2);
        }
        &.status2{
          color: var(--c3);
        }
      }
    }
  }

  .footer {
    display: flex;
    background-color: var(--white);
    padding: calc(var(--gap) * 5) calc(var(--gap) * 16);
    ::v-deep .van-button {
      height: calc(var(--w) * 40);
      &:not(:last-child){
        margin-right: calc(var(--gap) * 12);
      }
    }
  }
  .show-history-popup{
    display: flex;
    flex-direction: column;
    border-radius: var(--radius-lg) var(--radius-lg) 0 0;
    color: var(--g8);
    > .title {
      position: relative;
      margin-bottom: calc(var(--gap) * 8);
      height: calc(var(--w) * 48);
      font-size: var(--fs-lg);
      line-height: calc(var(--w) * 48);
      font-weight: 500;
      text-align: center;
      .clear-btn {
        position: absolute;
        margin: auto;
        top: 0;
        bottom: 0;
        right: calc(var(--gap) * 16);
        color: var(--tlc);
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        height: var(--lh-md);
      }
    }
    > .body {
      padding: 0 calc(var(--gap) * 16) calc(var(--gap) * 16);
      overflow: auto;
      >div{        
        padding: calc(var(--gap) * 8) 0;
      }
      div.line{        
        color: var(--g7);
        margin-top: calc(var(--gap) * 4);
        display: flex;
        .label{
          // white-space: nowrap;
          flex-shrink: 0;
        }
      }
      >div.van-hairline--bottom:last-child::after{
        display: none;
      }
    }
  }

}
</style>